export default __webpack_public_path__ + "static/media/cer2.4617d412.png";